<template>
  <div>
    <div class="right-title">
      <span>机构基本信息修改</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="top">
        <span class='s1'>机构基本信息修改</span>
      </div>
      <div class="userContent">
        <div class="userContent1">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item label="机构名称:">
              <div style="line-height: 40px;">{{ruleForm.organization_name}}</div>
            </el-form-item>
            <el-form-item label="机构对外展示名称:" prop="foreign_name">
              <el-input v-model="ruleForm.foreign_name" placeholder="请输入机构对外展示名称" style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="Logo:" prop="dataimg">
              <div class="imgBox">
                <img class="imgBoxImg" style="width: 126px;height: 126px;" @click="upFile" :src="headImg" alt="">
                <p style="color: #d9d9d9;height:30px;line-height: 30px;position: relative;">建议尺寸：126px*126px</p>
                <el-upload
                  style="display: none;"
                  accept="image/*"
                  action="" drag
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change='changeUpload'>
                  <i class="btnbtn" ref="upload"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="机构类型:" prop="orgType">
              <el-select  v-model="ruleForm.orgType" placeholder="请选择机构类型" style="width: 250px;">
                <el-option
                  v-for="item in leixingArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  label="所属领域:" prop="orgLinyu">
              <el-select multiple v-model="ruleForm.orgLinyu" placeholder="请选择所属领域" style="width: 250px;">
                <el-option
                  v-for="item in linyuArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机构规模:" prop="orgGuimo">
              <el-select v-model="ruleForm.orgGuimo" placeholder="请选择机构规模" style="width: 250px;">
                <el-option
                  v-for="item in guimoArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在区域:" required>
              <el-select v-model="ruleForm.addressId0" placeholder="请选择省" style="width: 150px;" @change="chioceSheng">
                <el-option v-for="item in addressId0Arr"
                           :key="item.id"
                           :label="item.categoryname"
                           :value="item.id"></el-option>
              </el-select>
              <span style="padding: 0 10px"></span>
              <el-select v-model="ruleForm.addressId1" placeholder="请选择市" style="width: 150px;" @change="chioceShi"
                         v-if="addressId1Arr.length>0">
                <el-option v-for="item in addressId1Arr"
                           :key="item.id"
                           :label="item.categoryname"
                           :value="item.id"></el-option>
              </el-select>
              <span style="padding: 0 10px"></span>
              <el-select v-model="ruleForm.addressId2" placeholder="请选择区/县" style="width: 150px;"
                         v-if="addressId2Arr.length>0">
                <el-option v-for="item in addressId2Arr"
                           :key="item.id"
                           :label="item.categoryname"
                           :value="item.id"></el-option>
              </el-select>

            </el-form-item>
            <el-form-item label="机构地址:" prop="orgAddress">
              <el-input v-model="ruleForm.orgAddress" placeholder="请输入机构地址" style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="机构简介:" prop="orgDesc">
              <el-input v-model="ruleForm.orgDesc" rows="6" type="textarea" placeholder="请输入机构简介"></el-input>
            </el-form-item>
<!--            <el-form-item label="视频上传:" prop="video">-->
<!--              &lt;!&ndash;            <el-input v-model="ruleForm.video" placeholder="请输入视频链接" style="width: 250px;"></el-input>&ndash;&gt;-->
<!--              <el-upload-->
<!--                :action="domain"-->
<!--                :data="QiniuData"-->
<!--                :on-error="uploadError"-->
<!--                :on-success="uploadSuccess"-->
<!--                :before-upload="beforeAvatarUpload"-->
<!--                :show-file-list="false"-->
<!--                multiple-->
<!--                :file-list="fileList">-->
<!--                <el-button size="small" type="primary">点击上传</el-button>-->
<!--              </el-upload>-->
<!--              <div v-if="ruleForm.video" style="margin-top: 20px;">-->
<!--                <video :src="ruleForm.video" controls="controls" style="width: 100%;"></video>-->
<!--                <el-button size="small" type="primary" @click="ruleForm.video = ''">删除</el-button>-->
<!--              </div>-->
<!--            </el-form-item>-->
            <el-form-item label="联系人:" prop="realName">
              <el-input v-model="ruleForm.realName" placeholder="请输入联系人姓名" style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="手机号码:" prop="phone">
              <el-input v-model.number="ruleForm.phone" placeholder="请输入手机号" style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:" prop="email">
              <el-input v-model="ruleForm.email" placeholder="请输入邮箱" style="width: 250px;"></el-input>
            </el-form-item>
<!--            <el-form-item label="乘车路线:" prop="busRoute">-->
<!--              <el-input v-model="ruleForm.busRoute" placeholder="请输入乘车路线" style="width: 250px;"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" @click="submitForm" class="btn">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>

    <footerBox class="footer"/>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            @realTime="realTime"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import config from  '../../../../config/index'
  import {genUpToken} from '../../../../tools/CryptoJS'
  export default {
    name: "jgDetail",
    data() {
      let chiosevideo = (rule, value, callback) => {
        let reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
        if (!value) {
          callback();
        } else if (value && !reg.test(value)) {
          callback(new Error('请输入以http://或https://开头的正确网址！'));
        } else {
          callback();
        }
      }
      return {
        user_id:'',
        QiniuData: {
          fname: '', //  文件名
          key: "", //文件名字处理
          token: "" //七牛云token
        },
        domain: "http://upload-z2.qiniup.com/", // 七牛云的上传地址（华南区）
        qiniuaddr: "http://zsglimg.emof.cn", // 七牛云的图片外链地址 你的七牛云里配置有
        uploadPicUrl: "", //提交到后台图片地址
        fileList: [],
        loadings: null,
        config: config, // 配置
        headImg: config.defaultHeadImg, // 默认头像
        ruleForm: {
          headimg: null,  // logo
          dataimg: '',    // 不带域名的logo
          foreign_name: '',    // 不带域名的logo
          orgType: '',    //机构类型
          orgLinyu: '',   //所属领域
          orgGuimo: '',   //机构规模
          orgDesc: '',    //机构简介
          addressId0: '', // 省ID
          addressId: '',  // 城市ID|区ID
          addressId1: '', // 城市ID
          addressId2: '', // 区ID
          orgAddress:'',  //  机构地址
          realName: '',   // 名字
          phone: '',      // 手机号
          email: '',       // 邮箱
          busRoute: '',    //  乘车路线
          video:'',
        },
        rules: {
          dataimg: [
            {required: true, message: '请上传Logo'}
          ],
          foreign_name: [
            {required: true, message: '请选择机构对外展示名称', trigger: 'blur'}
          ],
          orgType: [
            {required: true, message: '请选择机构类型', trigger: 'change'}
          ],
          orgLinyu: [
            {required: true, message: '请选择所属领域', trigger: 'change'}
          ],
          orgGuimo: [
            {required: true, message: '请选择机构规模', trigger: 'change'}
          ],
          addressId0: [
            {required: true, message: '请选择省', trigger: 'change'}
          ],
          addressId1: [
            {required: true, message: '请选择城市', trigger: 'change'}
          ],
          addressId2: [
            {required: true, message: '请选择区|县', trigger: 'change'}
          ],
          orgAddress: [
            {required: true, message: '请输入机构地址', trigger: 'blur'}
          ],
          orgDesc: [
            {required: true, message: '请输入机构简介', trigger: 'blur'}
          ],
          realName: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          video: [
            {validator: chiosevideo, trigger: 'blur'},
          ],
          phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {type: 'number', message: '请输入正确的数字手机号', trigger: 'blur'},
            {type: 'number', min: 10000000000, max: 99999999999, message: '请输入正确的手机号', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change'}
          ],
          // busRoute: [
          //   {required: true, message: '请输入乘车路线', trigger: 'blur'}
          // ],
        }, // 验证规则
        addressId0Arr: [], // 省下拉数据
        addressId1Arr: [], // 城市下拉数据
        addressId2Arr: [], // 区|县下拉数据
        leixingArr: [],      //  机构类型
        linyuArr: [],      //  机构类型
        guimoArr: [],      //  机构类型
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: '', // 裁剪图片的地址
          info: true, // 裁剪框的大小信息
          outputSize: 0.8, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式
          canScale: false, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          // autoCropWidth: 300, // 默认生成截图框宽度
          // autoCropHeight: 200, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [126, 126], // 截图框的宽高比例
          full: true, // 是否输出原图比例的截图
          canMoveBox: false, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: false, // 截图框是否被限制在图片里面
          infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        picsList: [],  //页面显示的数组
        // 防止重复提交
        loading: false,
      }
    },
    computed: {

      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.user_id = this.$route.params.id
      this.init()
      this.kname = this.KuName
      this.nowTime = this.getDate();
      var token;
      var policy = {};
      var bucketName = 'zhishiguanli';//你的七牛桶名称
      var AK = '_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3'; //你的七牛AK
      var SK = '15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z';//你的七牛SK
      var deadline = Math.round(new Date().getTime() / 1000) + 3600;
      policy.scope = bucketName;
      policy.deadline = deadline;
      token = genUpToken(AK, SK, policy);
      this.QiniuData.token = token;
    },
    methods: {
      init() {

        this.$api.apiContent.editClassification({
          parent_id: 1
        }).then(res => {
          this.leixingArr = res.data
        }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.editClassification({
          parent_id: 8
        }).then(res => {
          this.linyuArr = res.data
        }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.editClassification({
          parent_id: 14
        }).then(res => {
          this.guimoArr = res.data
        }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.getkexuanCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
        })
          .then(res => {
            this.addressId0Arr = res.data
          }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.jgDetailE({
          admin_id: this.user.id,
          user_id: this.user_id,
          examine:0
        }).then(res => {
          let _add = res.data.address_city_id.split('|')
          this.headImg = config.urlStr + '/' + res.data.logo
          this.ruleForm.headimg = config.urlStr + '/' + res.data.logo  // logo
          this.ruleForm.organization_name = res.data.organization_name  // 机构名称
          this.ruleForm.foreign_name = res.data.foreign_name  // 机构名称
          this.ruleForm.dataimg = res.data.logo    // 不带域名的logo
          this.ruleForm.orgType = res.data.organization_type   //机构类型
          let _arr = res.data.work_type.split(',')  //所属领域
          _arr.map(item=>{
            this.ruleForm.orgLinyu.push(Number(item))
          })
          this.ruleForm.orgGuimo = res.data.scale_id   //机构规模
          this.ruleForm.orgDesc = res.data.contents    //机构简介
          this.ruleForm.addressId = res.data.address_city_id  // 省id|城市ID|区ID
          this.ruleForm.addressId0 = Number(_add[0]) // 省ID
          this.ruleForm.addressId1 = Number(_add[1]) // 城市ID
          this.ruleForm.addressId2 = Number(_add[2]) // 区ID
          this.ruleForm.orgAddress = res.data.address,  //  机构地址
            this.ruleForm.realName = res.data.contact   // 名字
          this.ruleForm.phone = Number(res.data.telephone)      // 手机号
          this.ruleForm.email = res.data.email       // 邮箱
          this.ruleForm.video = res.data.video
          this.ruleForm.busRoute = res.data.bus_route
          this.getCity()
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate()
          })
        }).catch(e => {
          console.log(e)
        })

      },

      getCity(){
        this.$api.apiContent.getkexuanCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
          parentid: this.ruleForm.addressId0
        })
          .then(res => {
            this.addressId1Arr = res.data
          }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.getkexuanCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
          parentid: this.ruleForm.addressId1
        })
          .then(res => {
            this.addressId2Arr = res.data
          }).catch(e => {
          console.log(e)
        })
      },
      changeUpload(file,fileList) {
        console.log(file)
        console.log(fileList)
        const isLt5M = file.size / 1024 / 1024 < 3
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 3MB!')
          return false
        }
        this.fileinfo = file
        let  URL = window.URL || window.webkitURL
        // 上传成功后将图片地址赋值给裁剪框显示图片
        // this.$nextTick(() => {
          this.option.img = URL.createObjectURL(file.raw)
          // this.option.img = 'http://192.168.2.135:8888 /img/logo1.d7edfb46.png'
          console.log(this.option.img)
          this.dialogVisible = true
        // })

      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish() {
        this.$refs.cropper.getCropBlob((data) => {
          console.log(data)
          let fd = new window.FormData();
          fd.append('image', data)
          fd.append('admin_id', this.user.id,)
          this.$api.apiContent.file2(fd).then(res => {
            console.log(res)
            this.ruleForm.dataimg = res.data
            this.headImg = config.urlStr + '/' + res.data
            this.dialogVisible = false
          }).catch(e => {
            console.log(e)
            this.$message.error(e.info)
          })
        })
      },
      realTime (data) {
        this.previews = data
      },
      // 上传文件
      upFile() {
        document.querySelector('.btnbtn').click()
      },
      // logo上传之前的验证
      beforeUpload(file) {
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('userToken', this.$store.state.user.user_token)
        this.$api.apiMember.file(fd).then(res => {
          console.log(res)
          this.ruleForm.dataimg = res.data
          this.headImg = config.urlStr + '/' + res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
        return false
      },
      // 获取区|县的数据
      selectChange(state) {
        if (state === 1) this.ruleForm.addressId2 = ''
        this.$api.apiContent.getCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
          parentid: this.ruleForm.addressId1
        }).then(res => {
          let arr = []
          res.data.map(item => {
            let obj = {
              label: item.categoryname,
              value: item.id
            }
            arr.push(obj)
          })
          this.addressId2Arr = arr
        }).catch(e => {
          console.log(e)
        })
      },
      //  选择省
      chioceSheng() {
        this.$api.apiContent.getkexuanCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
          parentid: this.ruleForm.addressId0
        })
          .then(res => {
            this.addressId1Arr = res.data
          }).catch(e => {
          console.log(e)
        })
        this.ruleForm.addressId1 = ''
        this.ruleForm.addressId2 = ''
        this.$refs.ruleForm.validateField('address');
      },
      //  选择市
      chioceShi() {
        this.$api.apiContent.getkexuanCategoryDistrict({
          userId: this.user_id,
          admin_id: this.user.id,
          parentid: this.ruleForm.addressId1
        })
          .then(res => {
            this.addressId2Arr = res.data
          }).catch(e => {
          console.log(e)
        })
        this.ruleForm.addressId2 = ''
        this.$refs.ruleForm.validateField('address');
      },
      submitForm() {
        this.$refs.ruleForm.validate((valid) => {

          if (valid) {
            // 获取 城市 name
            let item0 = this.addressId0Arr.filter(item => {
              return item.id === this.ruleForm.addressId0
            })
            // 获取 城市 name
            let item1 = this.addressId1Arr.filter(item => {
              return item.id === this.ruleForm.addressId1
            })
            // 获取 区 name
            let item2 = this.addressId2Arr.filter(item => {
              return item.id === this.ruleForm.addressId2
            })
            this.$api.apiContent.setOrgInfo({
              admin_id: this.user.id,
              userId: this.user_id,
              logo: this.ruleForm.dataimg, // logo
              organization_type: this.ruleForm.orgType, // 机构类型
              foreign_name: this.ruleForm.foreign_name, // 机构类型
              work_type: this.ruleForm.orgLinyu.join(','), // 所属领域
              scale: this.ruleForm.orgGuimo, // 机构规模
              contents: this.ruleForm.orgDesc, // 机构简介
              address_city_id: this.ruleForm.addressId0 + '|' +this.ruleForm.addressId1 + '|' + this.ruleForm.addressId2, // 城市ID|区ID
              address_city_name:item0[0].categoryname + '|' +item1[0].categoryname + '|' + item2[0].categoryname, // 城市|区
              address:this.ruleForm.orgAddress,// 机构地址
              contact: this.ruleForm.realName, // 名字
              telephone: this.ruleForm.phone, // 手机号
              email: this.ruleForm.email, // 邮箱
              video:this.ruleForm.video,
              bus_route: this.ruleForm.busRoute, //  乘车路线
            }).then(() => {
              this.$message.success('修改成功')
            }).catch(e => {
              console.log(e)
              this.$message.error(e.info)
            })
          }
        })
      },



      //  上传前判断
      beforeAvatarUpload(file) {
        //这里的key给加上了时间戳，目的是为了防止上传冲突
        this.QiniuData.fname = file.name;
        this.QiniuData.key = `${this.nowTime}${file.name}`;
        this.loadings = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      //  上传成功
      uploadSuccess(response, file, fileList) {
        console.log(file);
        console.log(fileList);
        this.loadings.close();
        this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
        this.ruleForm.video = `${this.qiniuaddr}/${response.key}`;
      },
      //  上传失败
      uploadError(err, file, fileList) {
        console.log(err)
        console.log(file)
        console.log(fileList)
        this.loadings.close();
        this.$message({
          message: "上传出错，请重试！",
          type: "error",
          center: true
        });
      },
      //以下是时间戳函数
      getDate() {
        var myDate = new Date();
        //获取当前年
        var year = myDate.getFullYear();
        //获取当前月
        var month = myDate.getMonth() + 1;
        //获取当前日
        var date = myDate.getDate();
        var h = myDate.getHours(); //获取当前小时数(0-23)
        var m = myDate.getMinutes(); //获取当前分钟数(0-59)
        var s = myDate.getSeconds();
        //获取当前时间
        var now = year + this.conver(month) + this.conver(date) + this.conver(h) + this.conver(m) + this.conver(s) + "_";
        return now;
      },
      conver(s) {
        return s < 10 ? '0' + s : s;
      },
      //  返回上一页
      goBack() {
        this.$tools.goBack()
      },
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang='scss'>
  .top {
    display: flex;
    height: 55px;
    line-height: 55px;

    .s1 {
      display: inline-block;
      width: 150px;
      font-size: 15px;
      font-weight: bold;
      position: absolute;
      left: 36px;
    }

    .nobtn {
      height: 40px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      position: absolute;
      right: 20px;
      top: 17px;

    }
  }

  .hed {
    display: flex;
    padding: 10px 30px;

    .hed-l {
      width: 120px;
      height: 120px;
      img{
        display: block;
        width: 120px;
        height: 120px;
      }
    }

    .hed-r {
      flex: 1;
      margin-left: 30px;

      p {
        min-width: 33.3%;
        float: left;
        font-size: 14px;
        color: #333333;
        line-height: 40px;

        span {
          color: #999999;
        }
      }
    }

  }

  .jie {
    padding: 10px 30px;

    .j-p1 {
      font-size: 16px;
      color: #999999;
      line-height: 24px;
    }

    .j-p2 {
      font-size: 14px;
      color: #333;
      line-height: 30px;
      padding: 20px;
    }
  }

  .mode-box {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;

    .mode-title {
      line-height: 40px;
      font-size: 18px;
      font-size: 18px;
      font-weight: bold;

      i {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: #00a2ea;
      }

      span {
        float: right;
        width: 150px;
        line-height: 40px;
        border: 1px solid #00a2ea;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
      }
    }

    .info-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 0 30px;

      div {
        width: 25%;
        line-height: 30px;

        .left {
          color: #999;
        }
      }
    }

    .resume-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      padding-left: 40px;
      border-bottom: 1px solid #ddd;

      .left-text {
        width: 600px;

        .name {
          width: 390px;
          margin-right: 10px;
          font-size: 16px;
          font-weight: bold;
        }

        .time {
          color: #999;
          width: 200px;
        }
      }

      .right-text {
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px;

        span {
          display: block;
          color: #00a2ea;
          cursor: pointer;
        }
      }
    }
  }
  .cropper-content {
    .cropper {
      width: auto;
      height: 300px;
    }
  }
</style>
